<div class="page-container">
  <app-page-header title="Orders">
    <div class="header-actions" header-actions>
      <p-datepicker
        data-testid="orders-start"
        placeholder="Start date"
        dateFormat="mm/dd/yy"
        [showIcon]="true"
        [(ngModel)]="startDate"
      />
      <p-datepicker
        data-testid="orders-end"
        placeholder="End date"
        dateFormat="mm/dd/yy"
        [showIcon]="true"
        [(ngModel)]="endDate"
      />
      <p-button icon="pi pi-search" label="Apply" severity="primary" size="small" (onClick)="applyFilters()"></p-button>
      <p-button
        icon="pi pi-filter-slash"
        label="Clear"
        severity="secondary"
        [disabled]="!hasActiveFilters()"
        [text]="true"
        (onClick)="clearFilters()"
      ></p-button>
    </div>
  </app-page-header>

  @if (error()) {
    <p-message severity="error">Failed to load orders. Please try again.</p-message>
  }

  <p-table
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    dataKey="orderId"
    [lazy]="true"
    [loading]="loading()"
    [paginator]="true"
    [rows]="pageSize()"
    [showCurrentPageReport]="true"
    [totalRecords]="totalRecords()"
    [value]="orders()"
    (onPage)="onPage($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Order ID</th>
        <th>Group ID</th>
        <th>Acting User ID</th>
        <th>Status</th>
        <th>Type</th>
        <th>Created</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template let-order pTemplate="body">
      <tr [attr.data-testid]="'orders-row-' + order.orderId">
        <td>{{ order.orderId }}</td>
        <td>{{ order.groupId ?? '—' }}</td>
        <td>{{ order.actingUserId ?? '—' }}</td>
        <td>
          <p-tag severity="info" [value]="order.status"></p-tag>
        </td>
        <td>
          <p-tag severity="secondary" [value]="order.orderType"></p-tag>
        </td>
        <td>{{ order.createdOn | date: 'mediumDate' }}</td>
        <td>
          <p-button
            icon="pi pi-eye"
            label="View Details"
            severity="info"
            size="small"
            [text]="true"
            [routerLink]="['/orders', order.orderId]"
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-cell" colspan="7">
          <p-message severity="info">No orders found.</p-message>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <tr>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>
